'use strict';

angular.module('TurneroApp').component('coMotivos', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'motivosService',
        'utilsService',
        'TurneroAppConstant',
        function (motivosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.motivoCrear = false;
            ctrl.motivoModificar = false;
            ctrl.motivoConsultar = true;
            ctrl.motivoVer = false;
            ctrl.motivoAlta = new motivosService();
            ctrl.motivoEditar = new motivosService();
            ctrl.motivos = [];
            ctrl.focusBuscar = false;
            ctrl.filter = false;
            ctrl.exportControl = {};
            ctrl.permisos = TurneroAppConstant.Permisos;

            ctrl.$onChanges = function () {
                ctrl.grillaReload();
                ctrl.exportControl.isOpen = false
            };

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.limpiarMemoria = function () {
                ctrl.motivoCrear = false;
                ctrl.motivoModificar = false;
                ctrl.motivoConsultar = false;
                ctrl.motivoVer = false;
                ctrl.exportControl.isOpen = false
            };

            ctrl.grillaReload = function () {
                ctrl.errores = {
                    Tipo_Motivo: false,
                    N_Motivo: false,
                };
                ctrl.limpiarMemoria();
                ctrl.motivoConsultar = true;
                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos);
                }
            };

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.motivos = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObject = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = ['Motivo', 'Tipo Motivo'];
                    for (var i = 0; i < arrayObject.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObject[i].N_Motivo,
                            arrayObject[i].N_Tipo_Motivo
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Motivos',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            ctrl.getData = function (page, limit, tipo, callback) {
                ctrl.promise = motivosService.getfiltro({
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter,
                }).$promise.then(function (res) {
                    callback(tipo, res);
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            ctrl.crearMotivo = function () {
                ctrl.limpiarMemoria();
                ctrl.motivoCrear = true;
                ctrl.tLoadAlta();
            };

            ctrl.modificarMotivo = function (item) {
                ctrl.limpiarMemoria();
                ctrl.motivoModificar = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.verMotivo = function (item) {
                ctrl.limpiarMemoria();
                ctrl.motivoVer = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.eliminarMotivo = function (item) {
                swal({
                    title: "Eliminar Motivo",
                    text: "¿Desea quitar el motivo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!"
                }).then(function () {
                    motivosService.delete({ 'id': item.Id_Motivo }).$promise.then(function (res) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El motivo ha sido borrado correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req);
                    });

                });
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {

                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos);
            }
            ctrl.Excel = {
                down: function () { },
            }

        }
    ],
    template: require('./motivos.html')
});



// WEBPACK FOOTER //
// ./app/components/motivos/motivosComponent.js